<template>
    <div class="contents">
        <div class="tw-w-full">
            <div class="tw-flex tw-flex-wrap -tw-mx-3">
                <div class="tw-w-full tw-px-3">
                    <div class="wl-page-header">
<h1 class="wl-page-title">
                                    Daftar pesan masuk
                                </h1>
                        <div class="wl-page-actions">
                            <!-- <a v-on:click="exportContact" class="wl-btn wl-btn-ghost">
                                <i class="fas fa-download tw-text-[16px]" aria-hidden="true"></i>
                                Export pesan keluar
                            </a>
                            <download-csv ref="exportOutgoing" :data="exportJson" name="walabs_outgoing.csv"
                                style="display: none"></download-csv>
                            -->
                            <a v-on:click="toggleModal('action_incoming')" class="wl-btn wl-btn-primary">
                                Aksi
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tw-flex tw-flex-wrap -tw-mx-3">
                <div class="tw-w-full tw-px-3">
                    <div class="wl-panel tw-w-full tw-mb-8">
                        <IncomingTable />
                    </div>
                </div>
            </div>
            <modal name="action_incoming" :height="'auto'" :adaptive="true" :scrollable="true">
                <div style="margin: 20px">
                    <Action />
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import IncomingTable from "@/components/tables/Incoming.vue";
    import Action from "@/components/forms/incoming/Action.vue";
    import moment from 'moment'

    export default {
        components: {
            IncomingTable,
            Action
        },
        data() {
            return {
                group_dropdown: [],
                exportJson: []
            };
        },
        beforeDestroy(){
            this.$root.$off("toggle_modal", this.fnToggleModal);
        },
        mounted() {
            this.fnToggleModal = (param) => {
                this.toggleModal(param);
            }
            this.$root.$on("toggle_modal", this.fnToggleModal);
        },
        methods: {
            async loadGroups() {
                try {
                    let response = await this.$store.dispatch('group_list_dropdown')
                    this.group_dropdown = response.data.data.groups
                } catch (err) {
                    this.$toast.error("Server error")
                }
            },
            async emptyContact() {
                if (confirm("Semua data kontak akan terhapus, Yakin ?")) {
                    try {
                        let response = await this.$store.dispatch('contact_empty')
                        this.$toast.success(response.data.message);
                        this.$root.$emit("refresh_table", true)
                    } catch (err) {
                        this.$toast.error(err.response.data.message);
                    }
                }
            },
            async exportContact() {
                try {
                    this.$toast.info("Mohon Tunggu...");

                    await this.$store.dispatch('outgoing_export')
                        .then((response) => {
                            this.exportJson = response.data.data.outgoings

                            for (let i = 0; i < this.exportJson.length; i++) {
                                this.exportJson[i].jadwal = moment.utc(this.exportJson[i].jadwal).local().format("YYYY-MM-DD HH:mm:ss")
                                this.exportJson[i].delivery_schedule = moment.utc(this.exportJson[i].delivery_schedule).local().format("YYYY-MM-DD HH:mm:ss")
                                this.exportJson[i].created_at = moment.utc(this.exportJson[i].created_at).local().format("YYYY-MM-DD HH:mm:ss")
                                this.exportJson[i].updated_at = moment.utc(this.exportJson[i].updated_at).local().format("YYYY-MM-DD HH:mm:ss")
                            }
                        })
                        .then(() => {
                            this.$refs.exportOutgoing.$el.click()
                        })
                } catch (err) {
                    this.$toast.error(err);
                }
            },
            fillVar(val) {
                return val
            },
            toggleModal(param) {
                if (this.group_dropdown.length == 0) this.loadGroups()

                this.$modal.toggle(param);
            },
        },
    };
</script>
